import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChatListComponent } from './chat-list/chat-list.component';
import { ChatListDialogComponent } from './chat-list-dialog/chat-list-dialog.component';
import { ChatDialogComponent } from './chat-dialog/chat-dialog.component';
import { ChatMessagePipe } from './pipes/chat-message.pipe';
import { SharedLibraryModule, RecordMediaModule } from 'library-explorer';
import { ChatChannelMessagesListComponent } from './chat-channel-messages-list/chat-channel-messages-list.component';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { ChatChannelComponent } from './chat-channel/chat-channel.component';
import { ChatChannelImageComponent } from './chat-channel-image/chat-channel-image.component';
import { ChatMessageInputComponent } from './chat-message-input/chat-message-input.component';
import { ChatRecordMediaDialogComponent } from './chat-record-media-dialog/chat-record-media-dialog.component';
import { ChatLastMessagePipe } from './pipes/chat-last-message.pipe';
import { ChatMessageLoading } from './chat-message-loading/chat-message-loading';
import { ChatAdaptiveCardComponent } from './chat-adaptive-card/chat-adaptive-card.component';
import { ChatChannelV2Component } from './chat-channel-v2/chat-channel-v2.component';
import { ChatChannelMessagesListV2Component } from './chat-channel-messages-list-v2/chat-channel-messages-list-v2.component';

@NgModule({
  declarations: [
    ChatListComponent,
    ChatListDialogComponent,
    ChatDialogComponent,
    ChatMessagePipe,
    ChatChannelMessagesListComponent,
    ChatMessageComponent,
    ChatChannelComponent,
    ChatChannelImageComponent,
    ChatMessageInputComponent,
    ChatRecordMediaDialogComponent,
    ChatLastMessagePipe,
    ChatMessageLoading,
    ChatAdaptiveCardComponent,
    ChatChannelV2Component,
    ChatChannelMessagesListV2Component,
  ],
  imports: [
    CommonModule,
    TextFieldModule,
    SharedModule,
    SharedLibraryModule,
    RecordMediaModule
  ],
  exports: [
    ChatListComponent,
    ChatChannelComponent,
    ChatChannelImageComponent,
    ChatMessageInputComponent,
    ChatMessageComponent,
    ChatChannelV2Component,
    ChatChannelMessagesListV2Component,
  ]
})
export class ChatSharedModule { }
